module.exports = __webpack_public_path__ + "img/about_ico1.392df601.png";